import { render, staticRenderFns } from "./Naw1.vue?vue&type=template&id=b56b5fc0&scoped=true&"
import script from "./Naw1.vue?vue&type=script&lang=js&"
export * from "./Naw1.vue?vue&type=script&lang=js&"
import style0 from "./Naw1.vue?vue&type=style&index=0&id=b56b5fc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56b5fc0",
  null
  
)

export default component.exports